'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css2 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css3 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _css4 = require('antd/lib/radio/style/css');

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _css5 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _css6 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 个人设置表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var Option = _select2.default.Option;
var RadioGroup = _radio2.default.Group;


var AccountForm = _react2.default.createClass({
    displayName: 'AccountForm',
    onSubmit: function onSubmit(e) {
        e.preventDefault();
        _message2.default.error('没有权限修改账户');
    },
    render: function render() {
        var defaultValues = {
            name: "admin@examle.com",
            password: "***"
        };
        var _props$account = this.props.account,
            account = _props$account === undefined ? defaultValues : _props$account;
        var getFieldDecorator = this.props.form.getFieldDecorator;

        var formItemLayout = {
            labelCol: {
                span: 4
            },
            wrapperCol: {
                span: 20
            }
        };
        var tailFormItemLayout = {
            wrapperCol: {
                span: 14,
                offset: 6
            }
        };
        return _react2.default.createElement(
            _form2.default,
            { onSubmit: this.onSubmit },
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u8D26\u6237\u540D\u79F0' }),
                getFieldDecorator('name', {
                    rules: [{
                        required: true,
                        message: '请输入账户名'
                    }],
                    initialValue: account.name
                })(_react2.default.createElement(_input2.default, null))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5BC6\u7801' }),
                getFieldDecorator('owner_id', {
                    rules: [{
                        required: true,
                        message: '请输入密码'
                    }],
                    initialValue: account.password
                })(_react2.default.createElement(_input2.default, null))
            ),
            _react2.default.createElement(
                FormItem,
                tailFormItemLayout,
                _react2.default.createElement(
                    _button2.default,
                    { type: 'primary', htmlType: 'submit', size: 'large' },
                    '\u4FDD\u5B58'
                )
            )
        );
    }
});

exports.default = _form2.default.create({
    onValuesChange: function onValuesChange(props, values) {
        return console.log(values);
    }
})(AccountForm);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/account_form.js
// module id = 1572
// module chunks = 0